import React from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import { useSelector } from 'react-redux';
import { makeSelectClientDetails } from 'containers/Main/selectors';
import { useQuery } from 'react-query';
import { Link } from 'react-router-dom';
import getTopicEvidence from 'containers/TopicCenter/services/getTopicEvidences';
import useContentfulLocale from 'components/useContentfulLocale';
import {
  getEvidenceBaseApproach,
  getClientDetailsExcludedTopics,
} from 'containers/TopicCenter/utils';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import { getImageFile } from 'utils/stringUtils';
import Approaches from './Approaches';

const useStyles = makeStyles(() => ({
  image: {
    height: 68,
    borderRadius: 10,
    marginRight: 19,
  },
  description: {
    fontSize: 12,
    lineHeight: '16px',
  },
  title: {
    fontFamily: 'PoppinsSemiBold',
    fontSize: 14,
    lineHeight: '21px',
    color: '#01619B',
  },
  linkWrapper: {
    color: '#4B4B4B',
  },
}));

function TaggedTopicInfo({ data }) {
  const classes = useStyles();
  const topicId = _get(data, 'sys.id');
  const clientDetails = useSelector(makeSelectClientDetails());
  const excludedTopicSlugs = getClientDetailsExcludedTopics(clientDetails);
  const childTopics = _get(data, 'fields.childTopics', []);
  const ctfLocaleFilter = useContentfulLocale();

  // get evidence
  const { data: evidence, status } = useQuery(
    topicId && ['evidence', topicId, ctfLocaleFilter],
    getTopicEvidence,
  );

  if (!data || status === 'loading') return null;

  const relatedTopics = _get(data, 'fields.relatedTopics', null);
  const acceptedTopics = relatedTopics
    ? relatedTopics.filter(
        ({ fields }) =>
          _get(fields, 'reviewStatus') === 'Accepted' &&
          _get(fields, 'approach') === true,
      )
    : [];
  const approaches = getEvidenceBaseApproach({
    topics: acceptedTopics,
    evidence,
    types: childTopics,
    excludedTopicSlugs,
  });

  const imageSrc = getImageFile(_get(data, 'fields'));
  const { description, title, slug } = data.fields;
  return (
    <Box
      component="div"
      display="flex"
      flexDirection="column"
      mt="22px"
      flex="1 1 auto"
    >
      <Link to={`/topics/${slug}`} className={classes.linkWrapper}>
        <Box component="div" display="flex" flex="1">
          <img src={imageSrc} alt="" className={classes.image} />
          <Box component="div" display="flex" flexDirection="column" flex="1">
            <div className={classes.title}>{title}</div>
            <div className={classes.description}>{description}</div>
          </Box>
        </Box>
      </Link>
      <Approaches data={approaches} />
    </Box>
  );
}

TaggedTopicInfo.propTypes = {
  data: PropTypes.object,
};

export default React.memo(TaggedTopicInfo);
